import { useTheme } from "@repo/tokens";
import { Modal } from "@repo/ui";
import { Box, VStack, HStack, Icon, Text, Button, Title } from "@repo/ui";
import { useTranslation } from "react-i18next";
import type { NewProfileModalProps } from "./types";
import styles from "./NewProfileModal.module.scss";
import { useIsMobile, useIsTablet } from "@repo/utils";

export function NewProfileModal({
  isOpen,
  onClose,
  onContinue,
}: NewProfileModalProps) {
  const { t } = useTranslation("auth");
  const { theme } = useTheme();
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const renderBody = () => (
    <VStack gap="lg" className={styles.modalBody}>
      <HStack justify="flex-end" align="center">
        <Button
          onPress={onClose}
          variant="ghost"
          className={styles.closeButton}
        >
          <Icon name="close" size={30} color={theme.colors.primary[40]} />
        </Button>
      </HStack>

      <VStack align="center" gap="lg">
        <Icon name="infoGreen" size={41.67} color={theme.colors.success[60]} />

        <VStack gap="md">
          <Title variant="h3" webstyle={styles.title}>
            {t("newProfile.profileTitle")}
          </Title>

          <Box className={styles.infoBox}>
            <HStack align="center" gap="md">
              <Icon
                name="vector"
                width={18}
                height={18}
                color={theme.colors.tertiary[60]}
              />
              <Text
                variant="body"
                size="small"
                weight="regular"
                className={styles.infoText}
              >
                {t("newProfile.profile_warning")}
              </Text>
            </HStack>
          </Box>

          <VStack gap="xl">
            <Text
              variant="body"
              size="medium"
              weight="regular"
              align="center"
              className={styles.instructionText}
            >
              {t("newProfile.profile_sibling_instruction")}
            </Text>

            <Text
              variant="body"
              size="medium"
              weight="regular"
              align="center"
              className={styles.instructionText}
            >
              {t("newProfile.profile_confirmation")}
            </Text>
          </VStack>
        </VStack>
      </VStack>

      <VStack gap="md">
        <Button
          variant="primary"
          size="lg"
          className={styles.primaryButton}
          onPress={onContinue}
        >
          <Text className={styles.primaryButtonText}>
            {t("newProfile.continue")}
          </Text>
        </Button>

        <Button variant="ghost" onPress={onClose}>
          <Text
            variant="body"
            size="medium"
            weight="emphasized"
            align="center"
            color={theme.colors.primary[40]}
          >
            {t("newProfile.go_back")}
          </Text>
        </Button>
      </VStack>
    </VStack>
  );

  if (!isOpen) return null;

  return (
    <div className={styles.newProfileModalWrapper}>
      <Modal
        isModalOpen={isOpen}
        onClose={onClose}
        showHeader={true}
        showFooter={true}
        width={isMobile ? "100%" : isTablet ? "50%" : "30%"}
        height={"auto"}
        body={renderBody()}
      />
    </div>
  );
}
